import {
  type Assign,
  Combobox as ArkCombobox,
  PolymorphicProps,
  TagsInput,
} from "@ark-ui/react";
import { HTMLStyledProps } from "@zenchef/styled-system/jsx";
import {
  aromaCombobox,
  AromaComboboxVariantProps,
} from "@zenchef/styled-system/recipes";
import { slots } from "../../theme/recipes/combobox";
import { createStyleContext, Slot } from "../../utils/createStyleContext";

const { withProvider, withContext } = createStyleContext(aromaCombobox);

export interface ComboboxRootProps
  extends Assign<HTMLStyledProps<"div">, PolymorphicProps>,
    AromaComboboxVariantProps {}

export type ComboboxSlots = Slot<typeof aromaCombobox>;

export const slotsMaps: Record<ComboboxSlots, ComboboxSlots> = slots.reduce(
  (acc, slot) => ({ ...acc, [slot]: slot }),
  {} as Record<ComboboxSlots, ComboboxSlots>,
);

export const ComboboxRoot = withProvider<
  HTMLDivElement,
  Assign<
    HTMLStyledProps<"div">,
    ArkCombobox.RootProps<unknown> & AromaComboboxVariantProps
  >
>(ArkCombobox.Root, slotsMaps.root);

export const ComboboxTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<"button">, ArkCombobox.TriggerProps>
>(ArkCombobox.Trigger, slotsMaps.trigger);

export const ComboboxInput = withContext<
  HTMLInputElement,
  Assign<HTMLStyledProps<"input">, ArkCombobox.InputProps>
>(ArkCombobox.Input, slotsMaps.valueText);

export const ComboboxIndicator = withContext<
  HTMLElement,
  Assign<HTMLStyledProps<"div">, object>
>("div", slotsMaps.indicator);

export const ComboboxContent = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, ArkCombobox.ContentProps>
>(ArkCombobox.Content, slotsMaps.content);

export const ComboboxItem = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, ArkCombobox.ItemProps>
>(ArkCombobox.Item, slotsMaps.item);

export const ComboboxItemText = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<"span">, ArkCombobox.ItemTextProps>
>(ArkCombobox.ItemText, slotsMaps.itemText);

export const ComboboxItemIndicator = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, ArkCombobox.ItemIndicatorProps>
>(ArkCombobox.ItemIndicator, slotsMaps.itemIndicator);

export const TagsInputRoot = withProvider<
  HTMLDivElement,
  Assign<
    HTMLStyledProps<"div">,
    TagsInput.RootProps & AromaComboboxVariantProps
  >
>(TagsInput.Root, slotsMaps.tagsInputRoot);

export const TagsInputControl = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, TagsInput.ControlProps>
>(TagsInput.Control, slotsMaps.tagsInputControl);

export const TagsInputField = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, TagsInput.InputProps>
>(TagsInput.Input, slotsMaps.tagsInputField);
